module.exports = __webpack_public_path__ + "static/media/phone-mobile.4dc59665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/phone-mobile.svg
// module id = 153
// module chunks = 0